import { useEffect, useState } from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import { getStorage, setStorage } from 'forstok-ui-lib';

import type { SubjectType } from '@casl/ability';

import cookies from '../../../../utils/cookies';
import MyAbility from '../../../../utils/ability';

import type { TUser } from '../../../../types/share';
import type { TPermission } from '../../type';

import { Can } from '../../../../components/can/can';
import { getPermission } from '../../../../components/can/config';
import { destroyUser } from '../session';

const PrivateRoute = ({ as }: { as?: string }) => {
  const [auth, setAuth] = useState<boolean | undefined>();

  useEffect(() => {
    const controller = new AbortController();
    let effectStale = false;
    let isAuth = cookies.get('token') ? true : false;
    if (isAuth) {
      const users: TUser | undefined = getStorage('users', 'object');
      if (!users || !users?.profile_id || !users?.id || !users?.credentials) {
        const userCookies = cookies.get('users');
        if (userCookies) {
          setStorage('users', JSON.stringify(userCookies), 'local');
        } else {
          isAuth = false;
        }
      }
    }
    if (effectStale) {
      return;
    }
    if (isAuth) {
      const permission: TPermission[] = cookies.get('permission') || [];
      if (permission?.length) {
        const results = permission.map((_permission) => {
          return { id: _permission.id, group: _permission.group, name: _permission.name };
        });
        MyAbility.update(getPermission(results));
      }
    }
    setAuth(isAuth);

    return () => {
      controller?.abort();
      effectStale = true;
    };
  }, []);

  const ExcludeCan = ['chats'];

  if (auth === undefined) {
    return null;
  } else {
    if (auth) {
      if (MyAbility && as && !ExcludeCan.includes(as)) {
        return (
          <Can I="load" a={as as SubjectType} ability={MyAbility as any} passThrough>
            {(can) => (can ? <Outlet /> : <Navigate to="/restricted" />)}
          </Can>
        );
      } else {
        return <Outlet />;
      }
    } else {
      void destroyUser();
      return <Navigate to="/users/login?k=exp" />;
    }
  }
};

export default PrivateRoute;
